import { StripeAccountType } from "../DuesScreen/OrderForm/types";
import { CurrentMember, CurrentPerson } from "../fragments";

export interface EventDetailsQuery {
  event: {
    id: string;
    eventType: string;
    registrationType: string;
    title: string;
    description: string;
    registrationOpenAt: string;
    registrationCloseAt: string;
    startsAt: string;
    endsAt: string;
    timezone: string;
    cancelledAt: string | null;
    slug: string;
    bannerImageUrl: string;
    termsContent: string;
    printablePass: boolean;
    registrationFull: boolean;
    hasWaitlist: boolean;
    waitlistEnabled: boolean;
    offlineFee: LineItemPreview | null;
    orderPreview: OrderPreview | null;
    customFields: string[];
    facility?: {
      name: string;
    } | null;
    address1: string;
    address2?: string;
    city: string;
    state: string;
    zip: string;
    location: string;
    locationType: string;
    sessions: {
      id: string;
      orderKey: number;
      startsAt: string;
      endsAt: string;
      title: string;
      location: string;
      hasAvailability: boolean;
    }[];
  };
  currentMember: CurrentMember;
}

export enum RegistrationStatus {
  REGISTERED = "REGISTERED",
  CANCELED = "CANCELED",
}

export enum RegistrationType {
  ALL = "ALL",
  INDIVIDUAL = "INDIVIDUAL",
}

export interface EventRegistrationQuery {
  eventRegistration: {
    registeredAt: string | null;
    acceptedTerms: boolean;
    event: EventDetailsQuery;
    sessions: {
      id: string;
      startsAt: string;
      endsAt: string;
      title: string;
      location: string;
      orderKey: number;
    }[];
  };
}

export interface EventDetailsCardProps {
  event: EventDetailsQuery["event"];
  setEligibilityModalVisible: (value: boolean) => void;
  registrationEligible: boolean;
  registered: boolean;
  onRegistrationPress: () => void;
  onTicketPress: () => void;
  email: string;
  waitlistEntry?: EventWaitlistEntryQuery["eventWaitlistEntry"];
  onWaitlistPress: (eventId: string) => Promise<boolean>;
  waitlistEntryLoading: boolean;
  hasValidSpecialReg?: boolean;
}

export interface CurrentPersonQuery {
  currentPerson: CurrentPerson;
}

export interface EventEligibilityQuery {
  eventEligibility: {
    isEligible: boolean;
    eligibilityErrors: string[];
  };
}

export interface EventWaitlistEntryQuery {
  eventWaitlistEntry: {
    removed: boolean;
    promoted: boolean;
  };
}

export interface CurrentMemberQuery {
  currentMember: CurrentMember;
}

export interface OrderPreview {
  lineItemsTotal: number;
  lineItems: LineItemPreview[];
}

export interface LineItemPreview {
  name: string;
  notes: string | null;
  priceCents: number;
}

export interface ProductVariant {
  name: string;
  priceCents: string;
}

export interface RouteType {
  key: string;
  name: string;
  params: {
    slug: string;
  };
}

export interface FormData {
  sessions: Record<string, boolean>;
  disclaimer: boolean;
  dateOfBirth?: string;
  gender?: string;
  adaAccomodations?: boolean;
  additionalGuests?: number;
  showAdditionalGuests?: boolean;
}

interface GenericResponse {
  success: boolean;
  message?: string;
}

export interface CreateEventRegistrationMutation {
  createEventRegistration: GenericResponse;
}

export interface CreateEventWaitlistEntryMutation {
  createEventWaitlistEntry: GenericResponse;
}

export enum PaymentMethod {
  Card = "card",
  Bank = "us_bank_account",
}

export interface PaymentIntentResponseType {
  merchantDisplayName: string;
  paymentIntentClientSecret: string;
  total: number;
  orderId: string;
  customerEphemeralKeySecret?: string;
  customerId?: string;
  customerName?: string;
  customerEmail?: string;
  stripeAccount: StripeAccountType;
}

export interface CreatePaymentIntentResponseType {
  createPaymentIntent: PaymentIntentResponseType;
}

export interface CreateEventPaymentIntentInput {
  eventId: string;
  paymentMethod: PaymentMethod;
}
